import { fetcher } from './logical-backend-fetcher';
export { toTitleCaseSentence } from './string-utils';

type AddressByPinCode = {
  state: string;
  city: string;
  district: string;
  village: string;
  office: string;
  pincode?: string;
};

export async function getAddressSuggestionFromPinCode(
  pinCode: string,
  country: string
): Promise<AddressByPinCode | null> {
  try {
    const res = await fetcher(
      `form/address?pinCode=${pinCode}&country=${country}`,
      {
        method: 'GET',
      },
      ''
    );
    if (res.ok) {
      const result = await res.json();
      return result;
    }
  } catch (err) {
    console.error(err);
  }
  return null;
}
